import React from 'react'
import { useTranslation } from 'react-i18next'

const DonutChartStudentCheckIn = ({ size = 120, strokeWidth = 15, percentage = 50, mainColor = '#FC4C5999', backColor = '#6FCC8799', total = 100 }) => {
    const radius = (size - strokeWidth) / 2
    const circumference = 2 * Math.PI * radius
    const percentageOffset = (percentage / 100) * circumference
    const remainderOffset = circumference - percentageOffset
    const { t } = useTranslation()

    return (
        <div style={{ position: 'relative', width: size, height: size }}>
            <svg width={size} height={size}>
                <circle
                    cx={size / 2}
                    cy={size / 2}
                    r={radius}
                    fill="none"
                    stroke={mainColor}
                    strokeWidth={strokeWidth}
                    strokeDasharray={`${percentageOffset} ${circumference}`}
                    style={{
                        transform: 'rotate(-90deg)',
                        transformOrigin: 'center',
                        transition: 'stroke-dasharray 0.5s ease-in-out',
                    }}
                />
                <circle
                    cx={size / 2}
                    cy={size / 2}
                    r={radius}
                    fill="none"
                    stroke={backColor}
                    strokeWidth={strokeWidth}
                    strokeDasharray={`${remainderOffset} ${circumference}`}
                    strokeDashoffset={-percentageOffset}
                    style={{
                        transform: 'rotate(-90deg)',
                        transformOrigin: 'center',
                        transition: 'stroke-dasharray 0.5s ease-in-out, stroke-dashoffset 0.5s ease-in-out',
                    }}
                />
            </svg>
            <div
                style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '16px',
                    color: '#333',
                    textAlign: 'center',
                }}
            >
                <p className="text-[20px] leading-[25px] font-semibold text-darkenPurple ">{total}</p>
                <p className="text-[12px] leading-[20px] font-medium text-[#77768D] ">{t('Check-ins')}</p>
            </div>
        </div>
    )
}

export default DonutChartStudentCheckIn
